// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-eVHIK {
  background-color: #ff7f50;
}
.debug2-KvrWx {
  background-color: #6495ed;
}
.emdbtoast-tOevk {
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
}
.emdbtoast-tOevk .message-AwDwT {
  margin: 0 0 1rem 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}
.emdbtoast-tOevk .messageInfo-VebF2 {
  background: rgba(219, 234, 254, 0.8);
  border: solid #3b82f6;
  border-width: 0 0 0 6px;
  color: #3b82f6;
}
.emdbtoast-tOevk .messageSuccess-ravWG {
  background: rgba(228, 248, 240, 0.8);
  border: solid #1ea97c;
  border-width: 0 0 0 6px;
  color: #1ea97c;
}
.emdbtoast-tOevk .messageWarn-yB_Ba {
  background: rgba(255, 242, 226, 0.8);
  border: solid #cc8925;
  border-width: 0 0 0 6px;
  color: #cc8925;
}
.emdbtoast-tOevk .messageError-GODOj {
  background: rgba(255, 231, 230, 0.8);
  border: solid #ff5757;
  border-width: 0 0 0 6px;
  color: #ff5757;
}
.emdbtoast-tOevk .messageContent-jNfr1 {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  min-width: 350px;
  padding: 20px;
}
.emdbtoast-tOevk .messageContent-jNfr1 .icon-ArDf7 {
  width: 50px;
  align-self: center;
}
.emdbtoast-tOevk .messageContent-jNfr1 .messageText-EenuF {
  flex: 1;
}
.emdbtoast-tOevk .messageContent-jNfr1 .messageText-EenuF .summary-Kn8bs {
  font-size: 1.125em;
  font-family: "GTEestiBold";
}
.emdbtoast-tOevk .messageContent-jNfr1 .messageText-EenuF .detail-upg4b {
  font-family: AvenirBook;
  font-size: 1em;
}
.emdbtoast-tOevk .messageContent-jNfr1 .closeButton-GKBRz {
  width: 20px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmdbToast/emdbToast.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAa,eAAA;EAAiB,UAAA;EAAY,SAAA;EAAU,2BAAA;EAA6B,cAAA;AAsCjF;AAtCA;EAEQ,kBAAA;EACA,2CAAA;EACA,kBAAA;AAuCR;AA3CA;EAQQ,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAsCR;AAjDA;EAeQ,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAqCR;AAvDA;EAsBQ,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAoCR;AA7DA;EA6BQ,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAmCR;AAnEA;EAmCoB,aAAA;EAAe,SAAA;EAC3B,uBAAA;EACA,gBAAA;EAAkB,aAAA;AAqC1B;AA1EA;EAuCc,WAAA;EAAY,kBAAA;AAuC1B;AA9EA;EAwCsB,OAAA;AAyCtB;AAjFA;ECsCE,kBAAA;EDI8B,0BAAA;AA2ChC;AArFA;EA6CgB,uBAAA;ECPd,cAAA;ADmDF;AAzFA;EAgDqB,WAAA;EAAY,eAAA;AA6CjC","sourcesContent":["@import \"../../assets/css/theme\";\n\n.emdbtoast { position: fixed; top: 100px; left:50%; transform: translateX(-50%); z-index: 10000;\n    .message{\n        margin: 0 0 1rem 0;\n        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n        border-radius: 6px;\n    }\n\n    .messageInfo {\n        background: rgba(219, 234, 254, 0.8);\n        border: solid #3b82f6;\n        border-width: 0 0 0 6px;\n        color: #3b82f6;\n    }\n\n    .messageSuccess {\n        background: rgba(228, 248, 240, 0.8);\n        border: solid #1ea97c;\n        border-width: 0 0 0 6px;\n        color: #1ea97c;\n    }\n\n    .messageWarn{\n        background: rgba(255, 242, 226, 0.8);\n        border: solid #cc8925;\n        border-width: 0 0 0 6px;\n        color: #cc8925;\n    }\n\n    .messageError{\n        background: rgba(255, 231, 230, 0.8);\n        border: solid #ff5757;\n        border-width: 0 0 0 6px;\n        color: #ff5757;\n    }\n\n    .messageContent{display: flex; gap:10px;\n        align-items: flex-start;\n        min-width: 350px; padding: 20px;\n\n        .icon{width:50px; align-self: center;}\n        .messageText{ flex: 1;\n            .summary{\n                .font-base(18); font-family:\"GTEestiBold\";\n            }\n            .detail{\n                font-family:AvenirBook; .font-base(16);\n            }\n        }\n        .closeButton{width:20px; cursor:pointer;}\n    }\n\n}\n\n\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-eVHIK`,
	"debug2": `debug2-KvrWx`,
	"emdbtoast": `emdbtoast-tOevk`,
	"message": `message-AwDwT`,
	"messageInfo": `messageInfo-VebF2`,
	"messageSuccess": `messageSuccess-ravWG`,
	"messageWarn": `messageWarn-yB_Ba`,
	"messageError": `messageError-GODOj`,
	"messageContent": `messageContent-jNfr1`,
	"icon": `icon-ArDf7`,
	"messageText": `messageText-EenuF`,
	"summary": `summary-Kn8bs`,
	"detail": `detail-upg4b`,
	"closeButton": `closeButton-GKBRz`
};
export default ___CSS_LOADER_EXPORT___;
